export default class Subscription {
  constructor() {
    this.id;
    this.name;
    this.amount;
    this.dependantsCount;
    this.createdByUserId;
    this.createdAt;
    this.isDeleted;
    this.isIndividual;
  }

  set(setEntity) {
    this.id = setEntity.id;
    this.name = setEntity.name;
    this.amount = setEntity.amount;
    this.dependantsCount = setEntity.dependantsCount;
    this.createdByUserId = setEntity.createdByUserId;
    this.createdAt = setEntity.createdAt;
    this.isDeleted = setEntity.isDeleted;
    this.isIndividual = setEntity.isIndividual;
    return this;
  }
}
